import { useTranslations } from '@vocab/react';
import { Loader, Text } from 'braid-design-system';
import React from 'react';

import { FormDrawer } from 'src/components/FormDrawer/FormDrawer';
import { AVAILABILITY } from 'src/components/Router';
import { NEXT_ROLE_AVAILABILITY_FORM } from 'src/reducers/forms';

import { NextRoleDetail } from '../../ReadNextRole/NextRoleDetail/NextRoleDetail';
import { NextRoleSection } from '../../types';
import { EditAvailability } from '../EditAvailability/EditAvailability';
import { useAvailability } from '../data';

import translations from './.vocab';

export const ReadAvailability = () => {
  const { t } = useTranslations(translations);
  const { availability, error } = useAvailability();
  const hasAvailability = availability !== null && availability.id >= 0;

  return (
    <>
      <NextRoleDetail
        title={t('Availability')}
        section={NextRoleSection.availability}
      >
        {error ? (
          <Loader data={{ automation: 'availability-loading' }} />
        ) : (
          hasAvailability && <Text>{availability.description}</Text>
        )}
      </NextRoleDetail>
      <FormDrawer
        title={t('Availability')}
        component={EditAvailability}
        card={AVAILABILITY}
        formName={NEXT_ROLE_AVAILABILITY_FORM}
      />
    </>
  );
};
